(function ($) {
    $(function () {
        const relatedProgramsFilter = $('.js-related-program-filter');

        if (!relatedProgramsFilter.length) {
            return;
        }

        const relatedProgramPill = $('.js-related-program-filter-pill');

        function initRelatedProgramsPill() {
            relatedProgramsFilter.first().addClass('selected');
            relatedProgramPill.css('left', "8px");
            return;
        }

        function unique(array) {
            return array.filter(function (el, index, arr) {
                return index === arr.indexOf(el);
            });
        }

        function loadAllRelatedPrograms() {
            $('.js-related-programs-content').show();
            var ids = [];

            $('.js-toggle-favourite-program').each(function () {
                var id = $(this).data('id');
                ids.push(id);
            })

            var uniqueIds = unique(ids);

            uniqueIds.map(e => {
                var id = e.toString();
                $(`[data-id=${id}]`).not(":first").parent().hide();
            });


        }

        function animateRelatedProgramsPill(selectedId) {
            var width = selectedId == 0 ? "8px" : selectedId * 25 + "%";
            var property = $(window).width() <= 767 ? 'top' : 'left'
            relatedProgramPill.add(relatedProgramsFilter).removeClass('selected');
            $('.js-related-program-filter[data-id =' + selectedId + ']').addClass('selected')

            if (selectedId == 3) {
                relatedProgramPill.css(property, 'calc(75% - 8px)');
            } else {
                relatedProgramPill.css(property, width);
            }
        }

        relatedProgramsFilter.on('click', function (e) {
            e.preventDefault();
            $('.js-program-card').show();
            var selectedId = $(this).data('id');

            if (selectedId == '0') {
                loadAllRelatedPrograms();
                animateRelatedProgramsPill(selectedId);
            } else {
                $('.js-related-programs-content').hide();
                $('.js-related-programs-content[data-id =' + selectedId + ']').show()
                animateRelatedProgramsPill(selectedId);
            }
        });

        if ($(window).width() <= 767) {
            relatedProgramsFilter.slice(1).hide();

            relatedProgramsFilter.on('click', function () {
                if (relatedProgramsFilter.not(':hidden').length > 1) {
                    $(this).addClass('selected')
                    relatedProgramsFilter.not($(this)).hide();
                    $('.js-program-filter-dropdown').css('transform', 'rotate(90deg)');
                } else {
                    relatedProgramsFilter.show();
                    $('.js-program-filter-dropdown').css('transform', 'rotate(270deg)');
                }
            });
        }

        //$('.js-related-programs-content').not(":first").hide();
        initRelatedProgramsPill();
        loadAllRelatedPrograms();

    });
})(jQuery);